import React, { useId, useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, Collapse, Stack, Typography } from '@mui/material';

import type { ChatTraceStoredItem } from '~/services/TripPlannerService';

import ChatTraceJson from './ChatTraceJson';

interface Props {
  items: Array<ChatTraceStoredItem>;
}

export default function ChatTraceOtherItems({ items }: Props) {
  const [expanded, setExpanded] = useState(false);
  const contentId = useId();

  if (!items.length) {
    return null;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Button
        onClick={() => setExpanded((previous) => !previous)}
        aria-expanded={expanded}
        aria-controls={contentId}
        endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{ px: 0 }}
      >
        Other recorded items ({items.length})
      </Button>
      <Collapse in={expanded} unmountOnExit id={contentId}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Context and other records that could not be attached to a message or function call.
        </Typography>
        <Stack spacing={3}>
          {items.map((item) => (
            <Box key={item.id}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                {item.kind} · Item {item.itemSeq}
              </Typography>
              <ChatTraceJson value={item} />
            </Box>
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
}
